var map = {
	"./1.wav": 2225,
	"./10.wav": 2226,
	"./11.wav": 2227,
	"./12.wav": 2228,
	"./13.wav": 2229,
	"./14.wav": 2230,
	"./15.wav": 2231,
	"./16.wav": 2232,
	"./17.wav": 2233,
	"./18.wav": 2234,
	"./19.wav": 2235,
	"./2.wav": 2236,
	"./20.wav": 2237,
	"./21.wav": 2238,
	"./22.wav": 2239,
	"./23.wav": 2240,
	"./24.wav": 2241,
	"./25.wav": 2242,
	"./26.wav": 2243,
	"./27.wav": 2244,
	"./28.wav": 2245,
	"./29.wav": 2246,
	"./3.wav": 2247,
	"./30.wav": 2248,
	"./4.wav": 2249,
	"./5.wav": 2250,
	"./6.wav": 2251,
	"./7.wav": 2252,
	"./8.wav": 2253,
	"./9.wav": 2254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1248;